module.exports = __webpack_public_path__ + "static/media/14.1ecd9146.png";